/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
*/

const getUrlParameter = sParam => {
  return new URLSearchParams(window.location.search).get(sParam) || undefined
}

const track = name => {
  if (window.fathom) {
    window.fathom.trackEvent(name)
  }
}

const normalizeEmail = email => {
  if (email) {
    return email.toLowerCase().trim()
  } else {
    return null
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const customerEmail = normalizeEmail(
    window.localStorage.getItem('customer_email')
  )

  const emailInput = document.getElementById('email')
  if (emailInput && customerEmail) {
    emailInput.value = customerEmail
  }

  const form = document.getElementById('getintouch-form')
  const confirmation = document.getElementById('getintouch-confirmation')
  if (form) {
    form.addEventListener('submit', event => {
      event.preventDefault()
      form.style.display = 'none'
      if (confirmation) confirmation.style.display = ''

      const emailVal = normalizeEmail(
        document.getElementById('email')
          ? document.getElementById('email').value
          : null
      )
      if (emailVal) {
        window.localStorage.setItem('customer_email', emailVal)
      }

      track('Submitted get in touch')
    })
  }

  document.querySelectorAll('.getintouch').forEach(el => {
    el.addEventListener('click', () => {
      track('Clicked demo')
    })
  })

  document.querySelectorAll('.learnmore').forEach(el => {
    el.addEventListener('click', () => {
      track('Clicked learn more')
    })
  })

  document.querySelectorAll('.getstarted').forEach(el => {
    el.addEventListener('click', () => {
      track('Clicked pricing plan')
    })
  })

  document.querySelectorAll('.open-chat').forEach(el => {
    el.addEventListener('click', () => {
      window.loadBeacon && window.loadBeacon()
      window.Beacon && window.Beacon('open')
    })
  })

  const via = getUrlParameter('via')
  if (via) {
    track('Loaded referral link')
  }

  // Pricing tabs
  const tabLinks = document.querySelectorAll('[data-tab]')
  tabLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()
      const target = link.getAttribute('data-tab')
      tabLinks.forEach(l => l.classList.remove('active-tab'))
      link.classList.add('active-tab')
      document.querySelectorAll('.tab-pane').forEach(pane => {
        pane.classList.add('hidden')
        pane.classList.remove('active')
      })
      const targetPane = document.getElementById(target)
      if (targetPane) {
        targetPane.classList.remove('hidden')
        targetPane.classList.add('active')
      }
    })
  })
})
